import { create } from 'zustand';

interface UIState {
  // Sidebar
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;

  // Modals
  loginModalOpen: boolean;
  setLoginModalOpen: (open: boolean) => void;
  profileModalOpen: boolean;
  setProfileModalOpen: (open: boolean) => void;

  // Toast notifications
  toast: {
    message: string;
    type: 'success' | 'error' | 'info' | 'warning';
    isVisible: boolean;
  };
  showToast: (message: string, type?: 'success' | 'error' | 'info' | 'warning') => void;
  hideToast: () => void;

  // Search
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  searchModalOpen: boolean;
  setSearchModalOpen: (open: boolean) => void;
}

export const useUIStore = create<UIState>((set) => ({
  // Sidebar
  sidebarOpen: false,
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),

  // Modals
  loginModalOpen: false,
  setLoginModalOpen: (open) => set({ loginModalOpen: open }),
  profileModalOpen: false,
  setProfileModalOpen: (open) => set({ profileModalOpen: open }),

  // Toast
  toast: {
    message: '',
    type: 'info',
    isVisible: false,
  },
  showToast: (message, type = 'info') =>
    set({
      toast: { message, type, isVisible: true },
    }),
  hideToast: () =>
    set((state) => ({
      toast: { ...state.toast, isVisible: false },
    })),

  // Search
  searchQuery: '',
  setSearchQuery: (query) => set({ searchQuery: query }),
  searchModalOpen: false,
  setSearchModalOpen: (open) => set({ searchModalOpen: open }),
}));
